
function TermsAndConditionsPage() {
  return (
    <>
        {/* Page Title */}
        <h1 
          className="text-4xl font-bold text-center mb-12 text-black" 
          style={{ fontFamily: 'Poppins, sans-serif' }}
        >
          Terms and Conditions
        </h1>

        {/* Terms Content */}
        <div className="prose prose-lg max-w-none text-gray-800">
          <h2 className="text-2xl font-bold mb-4 text-indigo-900">1. Introduction</h2>
          
          <p>
            These Terms and Conditions ("Terms") govern your use of the services provided by Scott Higginbotham for League City Council Campaign ("Campaign," "we," "our," or "us"), and your use of our website ("Website"). By accessing our Website or engaging with our campaign, you agree to these Terms in their entirety. Do not continue to use our Website if you do not agree to take all of the terms and conditions stated on this page.
          </p>
          
          <p>
            The following terminology applies to these Terms and Conditions, Privacy Statement, and all Agreements: "Visitor," "You" and "Your" refers to you, the person accessing this Website. "The Campaign," "Ourselves," "We," "Our," and "Us" refers to Scott Higginbotham for League City Council Campaign. "Party," "Parties," or "Us" refers to both the Visitor and ourselves. All terms refer to the offer, acceptance, and consideration of payment necessary to undertake the process of our assistance to the Visitor in the most appropriate manner for the express purpose of meeting the Campaign's stated purposes, in accordance with and subject to prevailing law of the State of Texas, United States.
          </p>

          <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">2. Website Use</h2>
          
          <h3 className="text-xl font-bold mb-2 text-gray-800">2.1 License to Use Website</h3>
          <p>
            Unless otherwise stated, Scott Higginbotham for League City Council Campaign and/or its licensors own the intellectual property rights for all material on the Website. All intellectual property rights are reserved. You may access content from our Website for your own personal use subject to the restrictions set in these Terms.
          </p>

          <p>You must not:</p>
          <ul className="list-disc pl-8 my-4">
            <li>Republish material from our Website</li>
            <li>Sell, rent, or sub-license material from our Website</li>
            <li>Reproduce, duplicate, or copy material from our Website</li>
            <li>Redistribute content from our Website</li>
            <li>Use data mining, robots, or similar data gathering methods</li>
            <li>Circumvent, disable, or otherwise interfere with security features of the Website</li>
            <li>Use the Website in any way that is, or may be, damaging to the Website</li>
          </ul>

          <p>This Agreement shall begin on the date hereof.</p>

          <h3 className="text-xl font-bold mb-2 text-gray-800 mt-6">2.2 User Comments and Content</h3>
          <p>
            Parts of this Website may offer an opportunity for users to post and exchange opinions and information. The Campaign does not filter, edit, publish, or review Comments prior to their presence on the Website. Comments do not reflect the views and opinions of the Campaign, its agents, and/or affiliates. Comments reflect the views and opinions of the person who posts their views and opinions.
          </p>

          <p>
            To the extent permitted by applicable laws, the Campaign shall not be liable for the Comments or for any liability, damages, or expenses caused and/or suffered as a result of any use of and/or posting of and/or appearance of the Comments on this Website.
          </p>

          <p>
            The Campaign reserves the right to monitor all Comments and to remove any Comments which can be considered inappropriate, offensive, or cause a breach of these Terms and Conditions.
          </p>

          <p>You warrant and represent that:</p>
          <ul className="list-disc pl-8 my-4">
            <li>You are entitled to post Comments on our Website and have all necessary licenses and consents to do so</li>
            <li>The Comments do not invade any intellectual property right, including without limitation copyright, patent, or trademark of any third party</li>
            <li>The Comments do not contain any defamatory, libelous, offensive, indecent, or otherwise unlawful material which is an invasion of privacy</li>
            <li>The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity</li>
          </ul>

          <p>
            You hereby grant the Campaign a non-exclusive license to use, reproduce, edit, and authorize others to use, reproduce, and edit any of your Comments in any and all forms, formats, or media.
          </p>

          <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">3. Donations</h2>
          
          <p>
            When you make a donation to the Campaign, you agree to provide accurate and complete payment information. All donations are final and non-refundable.
          </p>
          
          <p>
            You acknowledge that all donations are subject to applicable state and federal campaign finance laws and regulations. The Campaign reserves the right to refuse or return any donation that it believes, in its sole discretion, may violate any law or regulation.
          </p>
          
          <p>
            The Campaign uses industry-standard security measures to protect your payment information. However, no data transmission over the Internet can be guaranteed to be 100% secure.
          </p>

          <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">4. Privacy</h2>
          
          <p>
            Your privacy is important to us. Our Privacy Policy, which is incorporated into these Terms by reference, explains how we collect, use, and disclose information about you.
          </p>

          <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">5. Disclaimer of Warranties</h2>
          
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE CAMPAIGN PROVIDES THE WEBSITE AND SERVICES "AS IS" AND "AS AVAILABLE," WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
          </p>

          <p>We do not warrant that:</p>
          <ul className="list-disc pl-8 my-4">
            <li>The Website will function uninterrupted, secure, or available at any particular time or location</li>
            <li>Any errors or defects will be corrected</li>
            <li>The Website is free of viruses or other harmful components</li>
            <li>The results of using the Website will meet your requirements</li>
          </ul>

          <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">6. Limitation of Liability</h2>
          
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE CAMPAIGN WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES.
          </p>

          <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">7. Governing Law</h2>
          
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the State of Texas, without regard to its conflict of law provisions. Any disputes arising from these Terms or our Website shall be resolved exclusively in the courts of Galveston County, Texas. You agree to submit to the personal jurisdiction of such courts.
          </p>

          <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">8. Modifications</h2>
          
          <p>
            We reserve the right to modify these Terms at any time. Changes will be effective upon posting to our Website. Your continued use of our Website after such changes constitutes acceptance of the modified Terms.
          </p>

          <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">9. Contact Information</h2>
          
          <p>
            If you have any questions about these Terms, please contact us at:
          </p>
          
          <div className="my-4">
            <p>Scott Higginbotham for League City Council Campaign</p>
            <p>League City, TX</p>
            <p>Email: <a href="mailto:scott@scottforleaguecity.com" className="text-indigo-700 hover:text-indigo-900">scott@scottforleaguecity.com</a></p>
          </div>

          <p className="mt-12 text-gray-600 text-center">
            <strong>Last Updated: March 13, 2025</strong>
          </p>
        </div>
    </>
  );
}

export default TermsAndConditionsPage;
